import React from 'react';
import { IconButton, Stack, Typography } from '@mui/material';
import { colors } from '@roku-web-ui/rds-theme';

import { IconReplay } from 'components/icons';

interface VideoReplayProps {
  onReplay: () => void;
}

export const VideoReplay = ({ onReplay }: VideoReplayProps) => (
  <Stack data-testid="events-overlay-video-replay" direction="column" alignItems="center" justifyContent="center">
    <IconButton
      aria-label="replay video"
      data-testid="button-events-overlay-replay"
      onClick={onReplay}
      sx={{
        '&:hover': {
          boxShadow: 'none',
        },
      }}
    >
      <Stack spacing={1} alignItems="center" direction="column">
        <IconReplay sx={{ fontSize: 60, color: colors.grey[400] }} />
        <Typography variant="body1" textAlign="center" color={colors.grey[400]}>
          Replay
        </Typography>
      </Stack>
    </IconButton>
  </Stack>
);
